import { SPLIT_IO_API_KEYS } from '../constants';

const getSplitioKey = (prodKey: string | null) => {
    if (prodKey) {
        return prodKey;
    }
    const { hostname } = window.location;
    return hostname.includes('dev')
        ? SPLIT_IO_API_KEYS.dev
        : SPLIT_IO_API_KEYS.evbqa;
};

export const getSplitioClient = (eventId: string, prodKey: string | null) => ({
    core: {
        authorizationKey: getSplitioKey(prodKey),
        key: eventId, // Unique id to track anonymous users
    },
    startup: {
        readyTimeout: 1.5,
    },
});

/* Split IO keys */
export const ENABLE_INTERSTITIAL_STEP =
    'login_as_interstitial_step_in_checkout';

export const PAYMENT_OPTIONS_LAST_ELEMENT =
    'checkout_payments_options_last_element';
